import { Card, Flex } from "antd";

import "./SubcontractorDashboardProjectsCard.scss";

import {
  ProjectsByStage,
  ProjectsDetails,
  SubcontractorProjects,
} from "projects/components";
import {
  ISubcontractorProjects,
  IProjectDetails,
  IProjectByStage,
} from "projects/models";
import variables from "../../../../../_variables.scss";

type Props = {
  loading?: boolean;
  subcontractorProjects?: ISubcontractorProjects;
  projectsDetails?: IProjectDetails[];
  projectsByStage?: IProjectByStage[];
};

export const SubcontractorDashboardProjectsCard = ({
  loading,
  subcontractorProjects,
  projectsDetails,
  projectsByStage,
}: Props) => {
  return (
    <Card
      loading={loading}
      bordered={false}
      data-testid='subcontractorDashboardProjectsCard'
    >
      <Flex vertical gap={variables.gap}>
        <h1>My Projects</h1>
        <SubcontractorProjects subcontractorProjects={subcontractorProjects ?? { totalProjects: 0, totalProjectsValue: 0 }} />
        <ProjectsDetails projectsDetails={projectsDetails ?? []} />
        <ProjectsByStage projectsByStage={projectsByStage ?? []} height={variables.defaultComponentHeight} />
      </Flex>
    </Card>
  );
};
